import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router";
import { AUTH_ROUTES } from "@/src/auth/constants/auth-routes";
import { getIsAuthenticated } from "@/src/auth/store/auth-selectors";
import { Button } from "@/src/common/components/ui";
import { useAppSelector } from "@/src/common/redux/store";
import { POST_ROUTES } from "@/src/post/constants/post-routes";

interface PublicCommunityHeaderProps {
	communityName: string;
	communityImage: string | null;
}

export function PublicCommunityHeader({ communityName, communityImage }: PublicCommunityHeaderProps) {
	const { t } = useTranslation("community");
	const navigate = useNavigate();
	const isAuthenticated = useAppSelector(getIsAuthenticated);

	const handlePrimary = () => {
		if (isAuthenticated) {
			navigate(POST_ROUTES.FEED);
		} else {
			navigate(AUTH_ROUTES.AUTH);
		}
	};

	return (
		<header className="flex items-center justify-between border-b border-divider px-6 py-4">
			<Link to="/" className="flex items-center gap-3">
				{communityImage && <img src={communityImage} alt={communityName} className="h-8 w-8 rounded-lg object-cover" />}
				<span className="font-semibold text-foreground">{communityName}</span>
			</Link>
			<Button variant="primary" size="sm" onPress={handlePrimary}>
				{isAuthenticated ? t("home_open_community") : t("home_sign_in")}
			</Button>
		</header>
	);
}
